<template>
  <div class="columns is-multiline">
    <label v-if="label" class="column is-12 mb-0 pb-0 has-text-centered">{{ label }}</label>
    <div class="column is-6">
      <input
        class="input"
        type="date"
        :placeholder="placeholderInicial"
        v-model="periodo.dataInicial"
        ref="inputPeriodoInicial"
        :required="required"
        :disabled="disabled"
        v-e2e="id + '-inicial'"
        @change="validarData"
      />
    </div>
    <div class="column is-6">
      <input
        class="input"
        type="date"
        data-tipo="final"
        :placeholder="placeholderFinal"
        v-model="periodo.dataFinal"
        ref="inputPeriodoFinal"
        :required="required"
        :disabled="disabled"
        v-e2e="id + '-final'"
        @change="validarData"
      />
      <div class="mensagemDeErro">
        <span v-if="isDataInvalida" class="is-block mt-3 campo-obrigatorio"> Período final deve ser maior ou igual que o período inicial. </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrfPeriodoInput',
  expose: ["limparInput"],
  props: {
    id: {
      type: String,
      default: 'componente-periodo'
    },
    label: String,
    dataInicial: String,
    dataFinal: String,
    required: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    permitirAnterior: {
      type: Boolean,
      default: true
    },
    mensagemCampoObrigatorio: String,
    placeholderInicial: {
      type: String,
      default: 'DD/MM/AAAA'
    },
    placeholderFinal: {
      type: String,
      default: 'DD/MM/AAAA'
    }
  },
  data() {
    return {
      periodo: {
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal
      },
      isDataInvalida: false,
      isInicialVazio: false,
      isFinalVazio: false
    };
  },
  methods: {
    validarData(e) {
      let data = e.target.value;
      if (
        this.isIntervaloInvalido(this.periodo.dataInicial, this.periodo.dataFinal) ||
        (this.required && (data == '' || this.periodo.dataInicial == '' || this.periodo.dataFinal == ''))
      ) {
        this.isDataInvalida = true;
        this.$emit('update:model-value', {
          dataInicial: this.periodo.dataInicial ? this.periodo.dataInicial : null,
          dataFinal: this.periodo.dataFinal ? this.periodo.dataFinal : null
        });
      } else {
        this.isDataInvalida = false;
      }
      this.$emit('update:model-value', this.periodo);
      return this.isDataInvalida;
    },

    isIntervaloInvalido(dataInicial, dataFinal) {
      if (!dataInicial || !dataFinal) return true;

      const startDate = new Date(dataInicial);
      const endDate = new Date(dataFinal);

      return startDate > endDate;
    },

    limparValidacao() {
      this.campoVazio = false;
      this.isDataInvalida = false;
    },

    limparInput(emit = true) {
      this.periodo.dataInicial = '';
      this.periodo.dataFinal = '';
      if (emit) {
        this.$emit('update:model-value', this.periodo);
      }
      this._forceClean()
      this.limparValidacao();
    },
    _forceClean() {
      const inputs = this.$el.querySelectorAll('input')
      inputs.forEach(e => {
        e.value = ''
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/variables.scss';
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

.data-invalida {
  border-color: #a94442;
}

.data-invalida:hover {
  border-color: #a94442;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}

input[disabled] {
  border-color: var(--ms-border-color, #cccccc);
}
.labelObrigatorio {
  color: #a94442;
}
</style>
